import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  /** Formatted meeting time in the user's timezone (e.g. "10pm"). */
  formattedTime: string;
  /** Day name in the user's timezone (e.g. "Friday"). */
  day: string;
  /** Formatted engagement start date (e.g. "May 8th"). */
  startDateLabel: string;
  /** Optional DST-aware timezone abbreviation (e.g. "PST", "GMT-11"). */
  timezoneAbbreviation?: string;
};

export function SchedulingCohortMessage({
  formattedTime,
  day,
  startDateLabel,
  timezoneAbbreviation,
}: Props) {
  return (
    <Type variant="body2" as="span">
      Your cohort is meeting at{" "}
      <span className="font-medium">
        {formattedTime}
        {timezoneAbbreviation ? ` ${timezoneAbbreviation}` : ""}
      </span>{" "}
      every {day}, starting {startDateLabel}.
    </Type>
  );
}

export default SchedulingCohortMessage;
